import { render, staticRenderFns } from "./LabOscillation.vue?vue&type=template&id=0f100e61&"
import script from "./LabOscillation.vue?vue&type=script&lang=ts&"
export * from "./LabOscillation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports